import React from 'react';
import styled from '@emotion/styled';
import { useLocale } from 'locale';
import { Route } from 'config/routes';
import { TextLabel } from 'ds/components/typography';
import { Link } from 'components/link';

const Root = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 8px 24px 8px 12px;
  border-radius: 100px;
  background: linear-gradient(92deg, #018489 0%, #003A42 100%);
  width: 100%;
`;

const TextWrapper = styled.div`
  ${({ theme }) => `
    color: ${theme.colors.neutrals.white};
    display: flex;
    flex-direction: column;
    gap: 3px;
  `}
`;

const BetaLabel = styled.div`
  ${({ theme }) => `
    background: ${theme.colors.label.yellow};
    padding: ${theme.spacing(0.5, 1)};
    border-radius: 100px;
    color: ${theme.colors.neutrals.grey1};
  `}
`;

const StyledLink = styled(Link)`
  display: block;
  width: 100%;
  text-decoration: none;
`;

const InvestorNeighbourhoodCta: React.FC = () => {
  const { t } = useLocale();
  const betaLabel = 'BETA';

  return (
    <Root>
      <TextWrapper>
        <TextLabel small>
          {t('investors.neighbourhoodCta.learnMore')}
        </TextLabel>
        <TextLabel weight="bold">
          {t('investors.neighbourhoodCta.goToInvestors')}
        </TextLabel>
      </TextWrapper>
      <BetaLabel>
        <TextLabel weight="bold" small>
          {betaLabel}
        </TextLabel>
      </BetaLabel>
    </Root>
  );
};

export const InvestorNeighbourhoodCtaAnchor: React.FC<{ neighbourhoodDocId: string }> = props => {
  const { neighbourhoodDocId } = props;

  if (!neighbourhoodDocId) {
    return null;
  }

  return (
    <StyledLink
      routeName={Route.InvestorsNeighbourhoodPage}
      routeParams={{ id: neighbourhoodDocId }}
      hideLinkParams
      target="_blank"
      rel="nofollow"
    >
      <InvestorNeighbourhoodCta />
    </StyledLink>
  );
};
